<template lang='pug'>
  v-dialog(v-model='Cotizaciones.dialog_requerimiento' max-width='500px' persistent  )
    template(v-slot:activator='{ on }')
      v-btn.mb-2( color='primary' dark v-on='on' @click='Cotizaciones.selectedKey=""' rounded ) Cotizar 
    v-card
      v-card-title
        v-edit-dialog( :return-value.sync='datos.titulo' label='Título' lazy )
          span.headline {{ datos.titulo }}
          template(v-slot:input='')
            v-text-field(v-model='datos.titulo' label='Editar título' single-line)
      v-card-text
        v-combobox(
          v-model="datos.provedores"
          :items="registro_provedores"
          label="Para:"
          multiple
          item-text='name'
          chips
        )
        v-edit-dialog( :return-value.sync='datos.mensaje' label='Contenido' lazy )
          p(v-html='datos.mensaje')
          template(v-slot:input='')
            v-textarea(v-model='datos.mensaje' label='Editar Contenido' single-line)
        v-layout  

          v-combobox(v-model='items' :items='registro_productos' :item-text='item=>`${item.descripcion} ${item.presentacion}`' label='Productos' return-object @change='agregar_productos(items)')
        v-data-table(:headers='encabezado' :items='Cotizaciones.datos.items' )
          template(v-slot:item.cantidad='props')
            v-text-field(type='number' v-model.number='props.item.cantidad' label='Cantidad' )
          template(v-slot:item.action='props')
            v-btn(@click='eliminar_productos(props.item)' icon)
              v-icon(color='primary' small ) far fa-trash-alt
      v-card-actions
        v-spacer
        v-btn( outlined @click='Cotizaciones.dialog_requerimiento=false') cerrar
        v-btn(color='primary'  @click='save();Cotizaciones.dialog_requerimiento=false') Guardar
</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
import {db} from '@/FirebaseConfig'
export default {
  data: () => ({
    provedores:'',
    ver_observaciones: false,
    items: '',
    encabezado: [
      {text: 'Descripcion', value: 'descripcion'},
      {text: 'Presentación', value: 'presentacion'},

      {text: 'Cantidad', value: 'cantidad'},
      {text: '', value: 'action'},
    ]
  }),
    methods: {
      ...mapActions({
        editItem: 'Cotizaciones/get',
        save: 'Cotizaciones/add',
        clearForm: 'Cotizaciones/clearForm',
      }),
      agregar_productos(items){
          if (items) this.Cotizaciones.datos.items.push(items)
          this.items = ''
      },
      eliminar_productos(items){
        this.datos.items.splice( this.datos.items.indexOf(items), 1)    
      },  
    },
    computed: {
      ...mapGetters({
        registro_provedores: 'Suppliers/record',
        registro_productos: 'Product/record',
      }),
       ...mapState({
      datos: state=> state.Cotizaciones.datos,
      Cotizaciones :state=> state.Cotizaciones,
      requerimientos: state=> state.Requerimientos,
    })
  },
}
</script>